Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }


    const uniqueId = Date.now();
    const getName = (name) => {
        return ctx.builder ? name + 'builder': name;
    };

    let otherAmountValue = false
;
__p += '\n<div class="frequency-amount-chooser-wrapper">\n    <div class="frequency-amount-chooser" id="frequency-amount-chooser">\n      <label id="frequency-chooser-label">' +
((__t = ( ctx.t(ctx.component.frequencies_label) )) == null ? '' : __t) +
'</label>\n        <div class="frequency-chooser">\n            ';

                ['once', 'monthly', 'quarterly', 'yearly'].forEach(freq => {
                    let freqAmounts = ctx.component[`amounts_${freq}`]

                    if (!freqAmounts) return;

                    let checked = ctx.component.default_frequency

                    if ('frequencyamounts' in ctx.data && 'frequency' in ctx.data.frequencyamounts) {
                      checked = ctx.data.frequencyamounts.frequency
                    }

                    for (let i = 0; i < Object.keys(freqAmounts).length; i++) {
                        if (freqAmounts[i].label !== '' && freqAmounts[i].value !== '') {
                            const id = `${ctx.component.key}-${freq}`
            ;
__p += '\n            <input\n                type="radio"\n                name="' +
((__t = ( getName('data[frequency]') )) == null ? '' : __t) +
'"\n                ref="input"\n                value="' +
((__t = ( freq )) == null ? '' : __t) +
'"\n                id="' +
((__t = ( id + uniqueId)) == null ? '' : __t) +
'"\n                aria-invalid="false"\n                data-frequency="' +
((__t = ( freq )) == null ? '' : __t) +
'"\n                class="form-control"\n                ';

                    if (checked === freq) {
                ;
__p += '\n                checked="checked"\n                ';

                    }
                ;
__p += '\n            >\n            <label for="' +
((__t = ( id + uniqueId )) == null ? '' : __t) +
'">\n                <nobr>' +
((__t = ( ctx.t(ctx.component[`frequency_${freq}_label`]) )) == null ? '' : __t) +
'</nobr>\n            </label>\n            ';

                            break;
                        }
                    }
                });
            ;
__p += '\n        </div>\n        <label id="amount-chooser-label">' +
((__t = ( ctx.t(ctx.component.amounts_label) )) == null ? '' : __t) +
'</label>\n        <div class="amount-chooser">\n            ';

                ['once', 'monthly', 'quarterly', 'yearly'].forEach(freq => {
                    let freqAmountsKey = `amounts_${freq}`;
                    let freqAmounts = ctx.component[freqAmountsKey];
                    let defaultAmount = ctx.component[`${freqAmountsKey}_default_amount`];
                    let defaultFreq = ctx.component.default_frequency;

                    if (!freqAmounts) return;

                    if ('frequencyamounts' in ctx.data && 'frequency' in ctx.data.frequencyamounts) {
                      defaultFreq = ctx.data.frequencyamounts.frequency
                    }

                    if ('frequencyamounts' in ctx.data && 'amount' in ctx.data.frequencyamounts && ctx.data.frequencyamounts.amount) {
                      // Lets see if the overwritten amount exists for "normal" usage
                      const amountExists = ctx.component[`amounts_${defaultFreq}`].find(item => item.value === +ctx.data.frequencyamounts.amount)

                      if (!amountExists) {
                        otherAmountValue = true
                      } else {
                        // Lets overwrite the `defaultAmount` so the value will be checked as expected
                        defaultAmount = +ctx.data.frequencyamounts.amount

                        // Make sure to reset the otherAmountValue
                        otherAmountValue = false
                      }
                    }
            ;
__p += '\n            <div\n                id="' +
((__t = ( freqAmountsKey + uniqueId )) == null ? '' : __t) +
'"\n                ';

                    if (freq !== defaultFreq) {
                ;
__p += '\n                style="display:none;"\n                ';

                    }
                ;
__p += '\n                class="frequency-amounts">\n            ';

                    for (let i = 0; i < Object.keys(freqAmounts).length; i++) {
                        if (freqAmounts[i].label !== '' && freqAmounts[i].value !== '') {
                            const amountId = `${freqAmountsKey}_${freqAmounts[i].value}`;
                            const checked = defaultFreq === freq && defaultAmount === freqAmounts[i].value
            ;
__p += '\n                <input\n                    type="radio"\n                    class="form-control frequency-amount radio"\n                    name="' +
((__t = ( getName('data[amount]') )) == null ? '' : __t) +
'"\n                    value="' +
((__t = ( freqAmounts[i].value )) == null ? '' : __t) +
'"\n                    id="' +
((__t = ( amountId + uniqueId )) == null ? '' : __t) +
'"\n                    aria-invalid="false"\n                    data-frequency="' +
((__t = ( freqAmounts[i].value )) == null ? '' : __t) +
'"\n                    ';

                        if (checked) {
                    ;
__p += '\n                    checked="checked"\n                    ';

                        }
                    ;
__p += '\n                >\n                <label\n                    for="' +
((__t = ( amountId + uniqueId )) == null ? '' : __t) +
'">\n                    <nobr>\n                        ' +
((__t = ( freqAmounts[i].label )) == null ? '' : __t) +
'\n                    </nobr>\n                </label>\n            ';

                        }
                    }
            ;
__p += '\n                ';

                    const otherId = `${freqAmountsKey}_other`;
                    if (ctx.component[`${freqAmountsKey}_min_amount_other`]) {
                ;
__p += '\n                <input\n                    type="radio"\n                    class="form-control frequency-amount radio"\n                    name="' +
((__t = ( getName('data[amount]') )) == null ? '' : __t) +
'"\n                    ';
 
                      if (otherAmountValue && freq === defaultFreq) {
                    ;
__p += '\n                    checked="checked"\n                    ';

                      }
                    ;
__p += '\n                    value="other"\n                    id="' +
((__t = ( otherId + uniqueId )) == null ? '' : __t) +
'"\n                    aria-invalid="false"\n                    data-frequency="other"\n                >\n                <label for="' +
((__t = ( otherId + uniqueId )) == null ? '' : __t) +
'">\n                    <nobr>' +
((__t = ( ctx.t(ctx.component.min_amount_other_label) )) == null ? '' : __t) +
'</nobr>\n                </label>\n                ';

                    }
                ;
__p += '\n            </div>\n            ';

                });
            ;
__p += '\n            <label\n                id="' +
((__t = ( 'frequency-amount-other-' + uniqueId )) == null ? '' : __t) +
'"\n                class="frequency-amount-other-label"\n            >\n                ' +
((__t = ( ctx.t(ctx.component.min_amount_other_input_label) )) == null ? '' : __t) +
'\n            </label>\n            <input\n                type="number"\n                name="' +
((__t = ( getName('data[amount]') )) == null ? '' : __t) +
'"\n                id="' +
((__t = ( 'frequency-amount-other-' + uniqueId )) == null ? '' : __t) +
'"\n                maxlength="10"\n                placeholder="' +
((__t = ( ctx.t(ctx.component.min_amount_other_input_placeholder) )) == null ? '' : __t) +
'"\n                data-validator="amount_other"\n                aria-invalid="false"\n                min="0"\n                class="form-control frequency-amount-other-input"\n                ';
 
                  if (otherAmountValue) { 
                ;
__p += '\n                  value="' +
((__t = ( ctx.data.frequencyamounts.amount / 100 )) == null ? '' : __t) +
'"\n                ';
 
                  } else {
                ;
__p += '\n                style="display: none;"\n                ';
 
                  }
                ;
__p += '\n            >\n        </div>\n    </div>\n</div>\n';

$(function () {
  let $container = $(ctx.instance.element);
  let $amountsContainer = $container.find('.amount-chooser');

  // Listen for change events
  $container.find('input').change(() => {
    handler();
  });

  /**
   * Handles the component state
   */
  let handler = function (init = false) {
    // Resolve the frequency
    let freq = frequencyChangeHandler();

    // Resolve the amount
    let amount = amountChangeHandler();

    // If we are initializing and the frequency amounts are already set, don't set them again
    if (init && ctx.data.frequencyamounts !== undefined) {
      return
    }

    ctx.setValue(
      {
        frequency: freq,
        amount: amount,
      },
      { modified: true }
    );
  };

  /**
   * Frequency change handler
   * @param string The chosen frequency
   */
  let frequencyChangeHandler = () => {
    let freq = $('input[name="'+getName("data[frequency]")+'"]:checked').val();

    if (!freq) {
      let defaultFreq = ctx.component['default_frequency'];

      if (defaultFreq) {
        $(`#frequencyamounts-${freq + uniqueId}`).prop('checked', true);
      }

      freq = defaultFreq;
    }

    $amountsContainer.find(`#amounts_${freq + uniqueId}`)
      .show() // show the related frequency amounts
      .siblings().hide(); // hide siblings

    return freq;
  };

  /**
   * Amount change handler
   * @param string The chosen amount
   * @param string The chosen frequency
   */
  let amountChangeHandler = function () {
    let freq = $('input[name="'+getName("data[frequency]")+'"]:checked').val();
    let amount = $(`#amounts_${freq + uniqueId} input[name="${getName("data[amount]")}"]:checked`).val();

    if (!amount) {
      let defaultAmount = ctx.component[`amounts_${freq}_default_amount`];

      if (defaultAmount) {
        $(`#amounts_${freq}_${defaultAmount.toString() + uniqueId}`).prop('checked', true);
      }

      return defaultAmount;
    }

    if (amount === 'other') {
      let $amountOther = $amountsContainer.find('input[type="number"][name="'+getName("data[amount]")+'"]');
      $amountOther.show();

      $amountsContainer.find('.frequency-amount-other-label').show()

      return $amountOther.val() ? $amountOther.val() * 100 : null;
    }

    return parseInt(amount, 10);
  };

  let defaultFreq = ctx.component.default_frequency;
  let freqAmountsKey = 'amounts_'+defaultFreq;
  let defaultAmount = ctx.component[`${freqAmountsKey}_default_amount`];

  // initial value
  handler(true);
});
;
__p += '\n';
return __p
}